// ===============
//     ROUTING
// ===============

export var ACTIVE_BANK_CHANGE = 'ACTIVE_BANK_CHANGE';
export var ACTIVE_BANK_ENTRY_CHANGE = 'ACTIVE_BANK_ENTRY_CHANGE';
export var ACTIVE_QUIZ_CHANGE = 'ACTIVE_QUIZ_CHANGE';
export var ACTIVE_QUIZ_SESSION_CHANGE = 'ACTIVE_QUIZ_SESSION_CHANGE';
export var NEW_QUIZ_ID = 'new';

// ===============
//  POST MESSAGE
// ===============

export var POST_TO_PARENT = 'POST_TO_PARENT';
export var GRADE_BY_QUESTION_SUBJECT = 'canvas.speedGraderGradeByQuestionChange';
export var REGISTER_MESSAGE_SUBJECT = 'quizzesNext.register';
export var SUBMISSION_CHANGE_SUBJECT = 'canvas.speedGraderSubmissionChange';
export var SUBMISSION_UPDATE_SUBJECT = 'quizzesNext.submissionUpdate';
export var GRADE_BY_QUESTION_NEXT = 'quizzesNext.nextStudent';
export var GRADE_BY_QUESTION_PREVIOUS = 'quizzesNext.previousStudent';

// ===============
//     FEATURES
// ===============

export var ADD_FEATURES = 'ADD_FEATURES';
export var REMOVE_FEATURES = 'REMOVE_FEATURES';

// ===============
//   QUIZ EXPORT
// ===============

export var START_QUIZ_EXPORT_JOB = 'START_QUIZ_EXPORT_JOB';

// ===============
//   QTI IMPORTS
// ===============

export var ADD_QTI_IMPORTS = 'ADD_QTI_IMPORTS';
export var CLEAR_QTI_IMPORTS = 'CLEAR_QTI_IMPORTS';
export var CREATE_QTI_IMPORT = 'CREATE_QTI_IMPORT';

// ===============
//     ALERTS
// ===============

export var ADD_ALERT = 'ADD_ALERT';
export var DEFAULT_ALERT_TIME = 5000;
export var REMOVE_ALERT = 'REMOVE_ALERT';
export var POLITE = 'polite';
export var ASSERTIVE = 'assertive';

// ===============
//  DRAG AND DROP
// ===============

export var HOVER_POSITION = 'HOVER_POSITION';
export var QUIZ_ENTRY_REF = 'quiz_entry';
export var SIDEBAR_ITEM_REF = 'sidebar_item';

// ===============
//  GRADE BY QUESTION
// ===============

export var DISMISS_GBQ_BANNER = 'DISMISS_GBQ_BANNER';
export var GRADE_BY_QUESTION_ENABLED = 'GRADE_BY_QUESTION_ENABLED';
export var GBQ_SET_ACTIVE_ITEM = 'GBQ_SET_ACTIVE_ITEM';

// ===============
//     MODAL
// ===============
export var CLOSE_MODAL = 'CLOSE_MODAL';
export var IMPORT_MODAL = 'IMPORT_MODAL';
export var OPEN_MODAL = 'OPEN_MODAL';
export var OPEN_ADD_CONTENT_MODAL = 'OPEN_ADD_CONTENT_MODAL';
export var OPEN_ADD_CONTENT_MODAL_DATA = 'OPEN_ADD_CONTENT_MODAL_DATA';
export var ADD_CONTENT_MODAL = 'ADD_CONTENT_MODAL';
export var CREATE_BANK_MODAL = 'CREATE_BANK_MODAL';
export var EDIT_BANK_MODAL = 'EDIT_BANK_MODAL';
export var ADD_TO_BANK_MODAL = 'ADD_TO_BANK_MODAL';
export var ADD_TO_BANK_MODAL_BANK_SELECTION = 'ADD_TO_BANK_MODAL_BANK_SELECTION';
export var COPY_MOVE_BANK_ENTRY_MODAL = 'COPY_MOVE_BANK_ENTRY_MODAL';
export var COPY_MOVE_BANK_ENTRY_MODAL_BANK_SELECTION = 'COPY_MOVE_BANK_ENTRY_MODAL_BANK_SELECTION';
export var COPY_MOVE_BANK_ENTRY_MODAL_KEEP_COPY = 'COPY_MOVE_BANK_ENTRY_MODAL_KEEP_COPY';
export var ITEM_FEEDBACK_MODAL = 'ITEM_FEEDBACK_MODAL';
export var ITEM_FEEDBACK_MODAL_ITEM = 'ITEM_FEEDBACK_MODAL_ITEM';
export var ITEM_FEEDBACK_MODAL_FEEDBACK = 'ITEM_FEEDBACK_MODAL_FEEDBACK';
export var ADD_BANK_ENTRY_MODAL = 'ADD_BANK_ENTRY_MODAL';
export var DELETE_STIMULUS_MODAL = 'DELETE_STIMULUS_MODAL';
export var OPEN_DELETE_STIMULUS_MODAL = 'OPEN_DELETE_STIMULUS_MODAL';
export var DELETE_STIMULUS_DATA = 'DELETE_STIMULUS_DATA';
export var DELETE_STIMULUS_MODAL_SELECTED_CHILDREN = 'DELETE_STIMULUS_MODAL_SELECTED_CHILDREN';
export var DELETE_STIMULUS_MODAL_DELETION_MODE = 'DELETE_STIMULUS_MODAL_DELETION_MODE';
export var MOVE_IMMUTABLE_MODAL = 'MOVE_IMMUTABLE_MODAL';
export var OUTSTANDING_QUIZZES_MODAL = 'OUTSTANDING_QUIZZES_MODAL';
export var OPEN_MOVE_IMMUTABLE_MODAL = 'OPEN_MOVE_IMMUTABLE_MODAL';
export var MOVE_IMMUTABLE_DATA = 'MOVE_IMMUTABLE_DATA';
export var PARENT_TYPE_QUIZ = 'PARENT_TYPE_QUIZ';
export var PARENT_TYPE_BANK = 'PARENT_TYPE_BANK';
export var PARENT_TYPE_QUIZ_SESSION = 'PARENT_TYPE_QUIZ_SESSION';
export var REGRADE_MODAL = 'REGRADE_MODAL';
export var SESSION_MANUAL_SUBMISSION_MODAL = 'SESSION_MANUAL_SUBMISSION_MODAL';
export var PRINT_FONT_SIZE_MODAL = 'PRINT_FONT_SIZE_MODAL';

// ===================
//     FILE UPLOAD
// ===================
export var CLEAR_ALT_TEXT = 'CLEAR_ALT_TEXT';
export var CLEAR_FILES = 'CLEAR_FILES';
export var FILE_RECEIVED = 'FILE_RECEIVED';
export var FILE_UPLOAD_STATUS = 'FILE_UPLOAD_STATUS';
export var FILE_UPLOAD_SELECT = 'FILE_UPLOAD_SELECT';
export var FILE_UPLOAD_IMPORTING = 'FILE_UPLOAD_IMPORTING';
export var FILE_UPLOAD_SUCCESS = 'FILE_UPLOAD_SUCCESS';
export var FILE_UPLOAD_FAILURE = 'FILE_UPLOAD_FAILURE';
export var FILE_UPLOAD_ERROR = 'FILE_UPLOAD_ERROR';
export var SET_ALT_TEXT = 'SET_ALT_TEXT';

// ===============
//     ERRORS
// ===============

export var CLEAR_ERRORS_SHOWING = 'CLEAR_ERRORS_SHOWING';
export var HIDE_ERROR = 'HIDE_ERROR';
export var SHOW_ERROR = 'SHOW_ERROR';
export var API_INPUT_VALIDATION_ERROR = 'API_INPUT_VALIDATION_ERROR';
export var CLEAR_ALL_INPUT_VALIDATION_ERRORS = 'CLEAR_ALL_INPUT_VALIDATION_ERRORS';

// =======================
//    HTTP STATUS CODES
// =======================

export var HTTP_STATUS_CODE_UNAUTHORIZED = 401;

// ===============
//     EDITING
// ===============

export var START_EDIT = 'START_EDIT';
export var END_EDIT = 'END_EDIT';
export var TOGGLE_EDIT = 'TOGGLE_EDIT';
// This is a class name that is used to determine if the user has clicked outside of the editing area,
// that's specified as a trigger to end editing: QUIZ-14118
export var END_EDITING_TRIGGER_CLASSNAME = 'endEditingTrigger';

// ===============
//     SIDEBAR
// ===============

export var TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export var SCROLL_TO_COMPONENT = 'SCROLL_TO_COMPONENT';
export var CLEAR_SCROLLED_COMPONENT = 'CLEAR_SCROLLED_COMPONENT';
export var SET_SIDEBAR_STIMULUS_IS_SHOWING = 'SET_SIDEBAR_STIMULUS_IS_SHOWING';

// ========================
//     FIXED SCROLL KEYS
// ========================

export var TITLE_SCROLL_KEY = 'TITLE_SCROLL_KEY';
export var INSTRUCTIONS_SCROLL_KEY = 'INSTRUCTIONS_SCROLL_KEY';
export var RESULTS_SCROLL_KEY = 'RESULTS_SCROLL_KEY';

// ===============
//     SEARCH
// ===============

export var BANKS_TOGGLE_INTERACTIONS_KEY = 'BankSearch.toggleInteractions';
export var BANKS_SEARCH_FILTER_KEY = 'BankSearch.toggleFilters';
export var SEARCH_RESET = 'SEARCH_RESET';
export var SEARCH_UPDATE = 'SEARCH_UPDATE';
export var SEARCH_TOGGLE = 'SEARCH_TOGGLE';
export var SEARCH_SET = 'SEARCH_SET';

// ===============
//     QUIZZES
// ===============

export var ADD_QUIZZES = 'ADD_QUIZZES';
export var ASSOCIATE_QUIZ_ENTRIES = 'ASSOCIATE_QUIZ_ENTRIES';
export var DISASSOCIATE_QUIZ_ENTRY = 'DISASSOCIATE_QUIZ_ENTRY';
export var ASSOCIATE_ITEM_ANALYSES = 'ASSOCIATE_ITEM_ANALYSES';
export var ASSOCIATE_QUIZ_ANALYSIS = 'ASSOCIATE_QUIZ_ANALYSIS';

// =========
//   ITEMS
// =========

export var ADD_ITEMS = 'ADD_ITEMS';
export var SHOULD_CLONE_ITEM = 'SHOULD_CLONE_ITEM';

// ===========
//   STIMULI
// ===========

export var ADD_STIMULI = 'ADD_STIMULI';

// ================
//   PRINTING
// ================
// actions
export var SET_PRINT_FONT_SIZE_PREFERENCE = 'SET_PRINT_FONT_SIZE_PREFERENCE'; // only set in the store
export var PERSIST_PRINT_FONT_SIZE_PREFERENCE = 'PERSIST_PRINT_FONT_SIZE_PREFERENCE'; // set in the store AND localStorage
// local storage key
export var QUIZ_PRINT_FONT_SIZE_PREFERENCE = 'QUIZ_PRINT_FONT_SIZE_PREFERENCE';
export var PRINT_CURRENT_PAGE = 'PRINT_CURRENT_PAGE';
export var PRINT_BLANK = 'PRINT_BLANK';

// ===========
//   QUIZ ENTRY REGRADES
// ===========

export var CREATE_QUIZ_ENTRY_REGRADE = 'CREATE_QUIZ_ENTRY_REGRADE';
export var REGRADE_SET_PAYLOAD = 'REGRADE_SET_PAYLOAD';
export var REGRADE_SET_SCORE_RECONCILIATION = 'REGRADE_SET_SCORE_RECONCILIATION';
export var REGRADE_TOGGLE_REGRADING_EDIT_MODE = 'REGRADE_TOGGLE_REGRADING_EDIT_MODE';

// =======================
//   QUIZ ENTRIES
// =======================

export var OCCLUDE_QUIZ_ENTRIES = 'OCCLUDE_QUIZ_ENTRIES';
export var ADD_QUIZ_ENTRIES = 'ADD_QUIZ_ENTRIES';
export var ADD_QUIZ_ENTRY = 'ADD_QUIZ_ENTRY';
export var DELETE_QUIZ_ENTRY = 'DELETE_QUIZ_ENTRY';
export var DELETE_STIMULUS_ENTRY = 'DELETE_STIMULUS_ENTRY';
export var MOVE_QUIZ_ENTRY = 'MOVE_QUIZ_ENTRY';
export var UPDATE_SAMPLE_ITEMS = 'UPDATE_SAMPLE_ITEMS';
export var QUIZ_ENTRY_GUID_SUFFIX = 'QUIZ_ENTRY_BUILD';

// ===============
//    QUIZ SESSIONS
// ===============
export var ADD_QUIZ_SESSIONS = 'ADD_QUIZ_SESSIONS';

// ========================
//   QUIZ SESSION STATUSES
// ========================
export var AUTOGRADING = 'autograding';
export var CREATING_RESPONSES = 'creating_responses';
export var CREATING_SESSION_ITEMS = 'creating_session_items';
export var FAILED_TO_START = 'failed_to_start';
export var FAILURE = 'failure';
export var GRADED = 'graded';
export var IN_PROGRESS = 'in_progress';
export var REOPENING_GRADED = 'reopening_graded';
export var NEEDS_GRADING = 'needs_grading';
export var PENDING = 'pending';
export var STARTING = 'starting';

// ===============
//    QUIZ SESSION EVENTS
// ===============
export var ADD_QUIZ_SESSION_EVENTS = 'ADD_QUIZ_SESSION_EVENTS';
export var UPDATE_TIMER_INFO = 'UPDATE_TIMER_INFO';
export var UPDATE_IS_TAKING = 'UPDATE_IS_TAKING';
export var UPDATE_TIMER_MINIMIZED = 'UPDATE_TIMER_MINIMIZED';
export var UPDATE_QUIZ_SESSION_STATUS_ON_PAGE_LOAD = 'UPDATE_QUIZ_SESSION_STATUS_ON_PAGE_LOAD';
export var SET_WS_TOKEN = 'SET_WS_TOKEN';

// =========================
//    QUIZ SESSION RESULTS
// =========================
export var ACTIVE_QUESTION = 'ACTIVE_QUESTION';
export var ADD_QUIZ_SESSION_RESULTS = 'ADD_QUIZ_SESSION_RESULTS';
export var CACHED_SESSION_ID = 'CACHED_SESSION_ID';

// ===============
//    SESSION ITEMS
// ===============
export var ADD_SESSION_ITEMS = 'ADD_SESSION_ITEMS';

// =========================
//    SESSION ITEM RESULTS
// =========================
export var ADD_SESSION_ITEM_RESULTS = 'ADD_SESSION_ITEM_RESULTS';

// ===============
//    RESPONSES
// ===============

export var LOAD_RESUME_DATA = 'LOAD_RESUME_DATA';
export var PREVIEW_RESPONSE = 'PREVIEW_RESPONSE';

// ==============================
//    EVENT GENERATING THINGS
// ==============================

export var QUIZ_SUBMISSION_EVENT = 'QUIZ_SUBMISSION_EVENT';
export var UPDATE_QUIZ_SUBMIT_FLAG = 'UPDATE_QUIZ_SUBMIT_FLAG';
export var RESPONSE = 'RESPONSE';
export var SESSION_STARTED_OR_RESUMED_EVENT = 'SESSION_STARTED_OR_RESUMED_EVENT';
export var RCE_EVENT = 'RCE_EVENT';
export var PAGE_BLURRED_EVENT = 'PAGE_BLURRED_EVENT';
export var PAGE_FOCUSED_EVENT = 'PAGE_FOCUSED_EVENT';

// ==================
//   MODIFICATIONS
// ==================

export var CLEAR_TEMPORARY_ITEM = 'CLEAR_TEMPORARY_ITEM';
export var CLEAR_TEMPORARY_BANK_ITEM = 'CLEAR_TEMPORARY_BANK_ITEM';
export var CLEAR_TEMPORARY_STIMULUS = 'CLEAR_TEMPORARY_STIMULUS';
export var CREATE_TEMPORARY_ITEM = 'CREATE_TEMPORARY_ITEM';
export var CREATE_TEMPORARY_BANK_ITEM = 'CREATE_TEMPORARY_BANK_ITEM';
export var MOVE_TEMPORARY_ITEM = 'MOVE_TEMPORARY_ITEM';
export var TEMPORARY_ITEM_ID = 'TEMPORARY_ITEM';
export var TEMPORARY_QUIZ_ENTRY_ID = 'TEMPORARY_QUIZ_ENTRY';
export var TEMPORARY_BANK_ENTRY_ID = 'TEMPORARY_BANK_ENTRY';
export var TEMPORARY_STIMULUS_ID = 'TEMPORARY_STIMULUS';
export var SET_NEXT_QUIZ_ENTRY = 'SET_NEXT_QUIZ_ENTRY';
export var CLEAR_NEXT_QUIZ_ENTRY = 'CLEAR_NEXT_QUIZ_ENTRY';
export var CLEAR_MODIFICATIONS = 'CLEAR_MODIFICATIONS';
export var ITEM_MODIFICATION = 'ITEM_MODIFICATION';
export var QUIZ_ENTRIES_MODIFICATION = 'QUIZ_ENTRIES_MODIFICATION';
export var QUIZ_MODIFICATION = 'QUIZ_MODIFICATION';
export var BANK_MODIFICATION = 'BANK_MODIFICATION';
export var QUIZ_SESSION_RESULT_MODIFICATION = 'QUIZ_SESSION_RESULT_MODIFICATION';
export var SESSION_ITEM_RESULTS_MODIFICATION = 'SESSION_ITEM_RESULTS_MODIFICATION';
export var STIMULUS_MODIFICATION = 'STIMULUS_MODIFICATION';
export var CREATE_TEMPORARY_BANK = 'CREATE_TEMPORARY_BANK';
export var CREATE_TEMPORARY_STIMULUS = 'CREATE_TEMPORARY_STIMULUS';
export var SET_RCE_ERROR = 'SET_RCE_ERROR';
export var SET_RCE_CONFIG = 'SET_RCE_CONFIG';

// =======================
//    INTERACTION TYPES
// =======================

export var ADD_INTERACTION_TYPES = 'ADD_INTERACTION_TYPES';
export var FORMULA_SLUG = 'formula';
export var RICH_FILL_BLANK_SLUG = 'rich-fill-blank';

// =======================
//    ANALYSES
// =======================

export var SET_QUIZ_ANALYSIS = 'SET_QUIZ_ANALYSIS';
export var SET_ITEM_ANALYSES = 'SET_ITEM_ANALYSES';
export var SET_STUDENT_ANALYSES = 'SET_STUDENT_ANALYSES';
export var SET_ANALYSIS_FETCH_IN_PROGRESS = 'SET_ANALYSIS_FETCH_IN_PROGRESS';
export var SET_STUDENT_ANALYSIS_FETCH_IN_PROGRESS = 'SET_STUDENT_ANALYSIS_FETCH_IN_PROGRESS';
export var SET_ANALYSIS_GENERATION_IN_PROGRESS = 'SET_ANALYSIS_GENERATION_IN_PROGRESS';
export var SET_STUDENT_ANALYSIS_REPORT_GENERATION_IN_PROGRESS = 'SET_STUDENT_ANALYSIS_REPORT_GENERATION_IN_PROGRESS';
export var SET_STATUS_POLLING_IN_PROGRESS = 'SET_STATUS_POLLING_IN_PROGRESS';
export var SET_STUDENT_ANALYSIS_STATUS_POLLING_IN_PROGRESS = 'SET_STUDENT_ANALYSIS_STATUS_POLLING_IN_PROGRESS';
export var SET_ANALYSIS_ERROR = 'SET_ANALYSIS_ERROR';
export var SET_STUDENT_ANALYSIS_ERROR = 'SET_STUDENT_ANALYSIS_ERROR';
export var ITEM_ANALYSES = 'item_analysis';
export var STUDENT_ANALYSES = 'student_analysis';

// =======================
//    ITEM BANKING
// =======================

export var ADD_BANKS = 'ADD_BANKS';
export var SET_BANK_FILTERS = 'SET_BANK_FILTERS';
export var ADD_BANK_ENTRIES = 'ADD_BANK_ENTRIES';
export var ARCHIVE_BANK_ENTRY = 'ARCHIVE_BANK_ENTRY';
export var ARCHIVE_BANK = 'ARCHIVE_BANK';
export var ASSOCIATE_ENTRIES = 'ASSOCIATE_ENTRIES';
export var DISASSOCIATE_ENTRY = 'DISASSOCIATE_ENTRY';
export var TEMPORARY_BANK_ID = 'TEMPORARY_BANK';
export var BUILD_TRAY_OPEN = 'BUILD_TRAY_OPEN';
export var TRAY_ALERT_OPEN = 'TRAY_ALERT_OPEN';
export var BUILD_TRAY_POSITION = 'BUILD_TRAY_POSITION';
export var BUILD_TRAY_STIMULUS_ID = 'BUILD_TRAY_STIMULUS_ID';
export var BUILD_TRAY_BUTTON_REF = 'BUILD_TRAY_BUTTON_REF';
export var SET_EDIT_BUTTON_FOCUS = 'SET_EDIT_BUTTON_FOCUS';
export var ADD_BANK_TO_QUIZ = 'ADD_BANK_TO_QUIZ';
export var ADD_BANK_TO_QUIZ_SAMPLE_NUM = 'ADD_BANK_TO_QUIZ_SAMPLE_NUM';
export var ADD_BANK_TO_QUIZ_POINTS_POSSIBLE = 'ADD_BANK_TO_QUIZ_POINTS_POSSIBLE';
export var ADD_BANK_TO_QUIZ_ALL_OR_RAND = 'ADD_BANK_TO_QUIZ_ALL_OR_RAND';
export var GET_BANK_ENTRIES_CALL = 'GET_BANK_ENTRIES_CALL';
export var GET_BANK_ENTRY_CALL = 'GET_BANK_ENTRY_CALL';
export var UPDATE_BANK_ENTRY_CALL = 'UPDATE_BANK_ENTRY_CALL';
export var CREATE_BANK_ENTRY_CALL = 'CREATE_BANK_ENTRY_CALL';
export var COPY_BANK_ENTRY_CALL = 'COPY_BANK_ENTRY_CALL';
export var UPDATE_BANK_CALL = 'UPDATE_BANK_CALL';
export var REMOVE_BANK_ENTRY_CALL = 'REMOVE_BANK_ENTRY_CALL';
export var SELECT_BANKS_OPTIONS = 'SELECT_BANKS_OPTIONS';
export var DELETE_BANK_CALL = 'DELETE_BANK_CALL';
export var REMOVE_BANK = 'REMOVE_BANK';
export var ADD_SHARED_BANKS = 'ADD_SHARED_BANKS';
export var UPDATE_SHARED_BANK_PERMISSION = 'UPDATE_SHARED_BANK_PERMISSION';
export var REMOVE_SHARED_BANK = 'REMOVE_SHARED_BANK';
export var PARENT_TYPE_ADDING_TO_BANK = 'PARENT_TYPE_ADDING_TO_BANK';

// =======================
//    TAG ASSOCIATIONS
// =======================

// Name of fetcher call type when getting tag suggestions
export var GET_TAG_SUGGESTIONS = 'GET_TAG_SUGGESTIONS';
// Name of Redux action that sets tag associations
export var SET_TAG_SUGGESTIONS = 'SET_TAG_SUGGESTIONS';

// Name of Redux action that removes a tag from a given entity
export var REMOVE_TAG_ASSOCIATION = 'REMOVE_TAG_ASSOCIATION';
// Name of fetcher call type when deleting a tag association
export var DELETE_TAG_ASSOCIATION = 'DELETE_TAG_ASSOCIATION';

// Name of Redux action that adds a tag for a given entity
export var ADD_TAG_ASSOCIATION = 'ADD_TAG_ASSOCIATION';
// Name of fetcher call type when adding a tag association
export var CREATE_TAG_ASSOCIATION = 'CREATE_TAG_ASSOCIATION';

// Name of Redux action that sets pending tag additions to a given entity
export var SET_PENDING_ADDITION_TAG_ASSOCIATIONS = 'SET_PENDING_ADDITION_TAG_ASSOCIATIONS';
// Name of Redux action that removes a single pending tag addition to a given entity
export var REMOVE_PENDING_ADDITION_TAG_ASSOCIATION = 'REMOVE_PENDING_ADDITION_TAG_ASSOCIATION';

// Name of Redux action that sets pending tag deletions to a given entity
export var SET_PENDING_DELETION_TAG_ASSOCIATIONS = 'SET_PENDING_DELETION_TAG_ASSOCIATIONS';
// Name of Redux action that removes a single pending tag deletion to a given entity
export var REMOVE_PENDING_DELETION_TAG_ASSOCIATION = 'REMOVE_PENDING_DELETION_TAG_ASSOCIATION';

// Name of Redux action that sets the current tag input in the tag select
export var SET_TAG_INPUT = 'SET_TAG_INPUT';

// =======================
//    MATCHING COMPONENTS
// =======================

export var MATCH_LIST = 'matchList';
export var CATEGORIES = 'categories';

// ================
//    MODERATION
// ================

export var CLOSE_MODERATE_TRAY = 'CLOSE_MODERATE_TRAY';
export var OPEN_MODERATE_TRAY = 'OPEN_MODERATE_TRAY';

// ===============
//     UI STATE
// ===============

export var CLEAR_UI = 'CLEAR_UI';
export var MERGE_UI = 'MERGE_UI';
export var SET_UI = 'SET_UI';
export var TOGGLE_UI = 'TOGGLE_UI';
export var MODERATE_QUIZ_SESSION_PAGINATION = 'MODERATE_QUIZ_SESSION_PAGINATION';
export var BANKS_BANK_FILTERS = 'BANKS_BANK_FILTERS';
export var BANKS_BANK_PAGINATION = 'BANKS_BANK_PAGINATION';
export var BANKS_BANK_ENTRY_PAGINATION = 'BANKS_BANK_ENTRY_PAGINATION';
export var STUDENT_ACCESS_CODE_VALUE = 'STUDENT_ACCESS_CODE_VALUE';
export var STUDENT_ACCESS_CODE_STATUS = 'STUDENT_ACCESS_CODE_STATUS';
export var DELETED_QUIZ_ENTRY = 'DELETED_QUIZ_ENTRY';
export var MOVED_QUIZ_ENTRY = 'MOVED_QUIZ_ENTRY';
export var MOVED_IN_SIDEBAR = 'MOVED_IN_SIDEBAR';
export var LOADED_API_FEATURES = 'LOADED_API_FEATURES';

// ===============
//     CALLS
// ===============

export var CALL_STATUS = 'CALL_STATUS';
export var CLONE_QUIZ_ENTRY_CALL = 'CLONE_QUIZ_ENTRY_CALL';
export var CREATE_ITEM_CALL = 'CREATE_ITEM_CALL';
export var CREATE_QUIZ_ENTRY_CALL = 'CREATE_QUIZ_ENTRY_CALL';
export var CREATE_STIMULUS_CALL = 'CREATE_STIMULUS_CALL';
export var DELETE_QUIZ_ENTRY_CALL = 'DELETE_QUIZ_ENTRY_CALL';
export var FILE_UPLOAD_CALL = 'FILE_UPLOAD_CALL';
export var FILE_UPLOAD_URL_CALL = 'FILE_UPLOAD_URL_CALL';
export var GRADING_INFO_CALL = 'GRADING_INFO_CALL';
export var MOVE_QUIZ_ENTRY_CALL = 'MOVE_QUIZ_ENTRY_CALL';
export var OQAAT_NO_BACKTRACKING_NEXT_ITEM_FETCH_CALL = 'OQAAT_NO_BACKTRACKING_NEXT_ITEM_FETCH_CALL';
export var QUIZ_SAVE_CALL = 'QUIZ_SAVE_CALL';
export var QUIZ_SESSIONS_FETCH_CALL = 'QUIZ_SESSIONS_FETCH_CALL';
export var QUIZ_SESSION_AUTOSUBMIT_CALL = 'QUIZ_SESSION_AUTOSUBMIT_CALL';
export var QUIZ_SESSION_EVENTS_FETCH_CALL = 'QUIZ_SESSION_EVENTS_FETCH_CALL';
export var QUIZ_SESSION_FETCH_CALL = 'QUIZ_SESSION_FETCH_CALL';
export var QUIZ_SESSION_RESULT_FETCH_CALL = 'QUIZ_SESSION_RESULT_FETCH_CALL';
export var QUIZ_SESSION_REOPEN_CALL = 'QUIZ_SESSION_REOPEN_CALL';
export var QUIZ_SESSION_RESET_CALL = 'QUIZ_SESSION_RESET_CALL';
export var SET_CALLBACKS_STATUS = 'SET_CALLBACKS_STATUS';
export var UPDATE_ITEM_CALL = 'UPDATE_ITEM_CALL';
export var UPDATE_QUIZ_ENTRY_CALL = 'UPDATE_QUIZ_ENTRY_CALL';
export var UPDATE_STIMULUS_CALL = 'UPDATE_STIMULUS_CALL';
export var SESSION_ITEMS_FETCH_CALL = 'SESSION_ITEMS_FETCH_CALL';

// ===============
//    TAKING CALLS
// ===============

export var BACKTRACKING_NEXT_QUESTION = 'BACKTRACKING_NEXT_QUESTION';
export var PREVIOUS_QUESTION = 'PREVIOUS_QUESTION';
export var SHOW_OR_RESUME_QUIZ = 'SHOW_OR_RESUME_QUIZ';
export var START_QUIZ_CALL = 'START_QUIZ_CALL';
export var SUBMIT_QUIZ = 'SUBMIT_QUIZ';
export var SET_CURRENT_SESSION_ITEM_POSITION = 'SET_CURRENT_SESSION_ITEM_POSITION';
export var CLEAR_FOCUS_CURRENT_SESSION_ITEM = 'CLEAR_FOCUS_CURRENT_SESSION_ITEM';
export var SET_FOCUS_TITLE_AND_INSTRUCTIONS = 'SET_FOCUS_TITLE_AND_INSTRUCTIONS';

// =============
//    HELPERS
// =============

export var DO_NOTHING = 'DO_NOTHING';

// =============
//    COMPONENT TYPES
// =============
export var COMPONENT_EDIT = 'EDIT';
export var COMPONENT_SHOW = 'SHOW';
export var COMPONENT_TAKE = 'TAKE';
export var COMPONENT_RESULT = 'RESULT';

// ==============
//    CONFIG
// ==============
export var SET_API_ENDPOINT = 'SET_API_ENDPOINT';
export var SET_CANVAS_ORIGIN = 'SET_CANVAS_ORIGIN';
export var SET_USER_TOKEN = 'SET_USER_TOKEN';

// ==============
//   QUIZ REPORTING ANALYTICS
// =============
export var ADD_ITEM_ANALYSES = 'ADD_ITEM_ANALYSES';
export var ADD_QUIZ_ANALYSIS = 'ADD_QUIZ_ANALYSIS';
export var QUIZ_ANALYSIS_NOT_FOUND = 'QUIZ_ANALYSIS_NOT_FOUND';
export var ITEM_ANALYSIS_NOT_FOUND = 'ITEM_ANALYSIS_NOT_FOUND';
export var TOGGLE_ITEM_ANALYSIS_EXPANDED = 'TOGGLE_ITEM_ANALYSIS_EXPANDED';

// =============
//   SKIP TO CONTENT
// =============
export var SKIP_TO_CONTENT_FOCUS = 'SKIP_TO_CONTENT_FOCUS';
export var SKIP_TO_CONTENT_BLUR = 'SKIP_TO_CONTENT_BLUR';

// =============
//   OUTCOMES
// =============
export var SET_CONTEXT_UUID = 'SET_CONTEXT_UUID';
export var SET_OUTCOMES_ENDPOINT = 'SET_OUTCOMES_ENDPOINT';
export var SET_OUTCOMES_TOKEN = 'SET_OUTCOMES_TOKEN';
export var SET_EXTERNAL_ACCOUNT_UUID = 'SET_EXTERNAL_ACCOUNT_UUID';

// ================
//   PERMISSIONS
// ================
export var CAN_EDIT = 'edit';
export var READ_ONLY = 'read';
export var REMOVED_ACCESS = 'removed_access';

// ================
//   SHARED BANK ENTITY TYPES
// ================
export var SHARED_WITH_USER = 'user';
export var SHARED_WITH_COURSE = 'course';
export var SHARED_WITH_ACCOUNT = 'account';

// ================
//   INST-UI STYLES
// ================
export var XSMALL_SIDE_MARGIN = '0 x-small';

// ================
//   SELECT
// ================
export var SELECT_EMPTY_OPTION = 'empty-option';
export var SELECT_EMPTY_OPTION_TEXT = '---';

// ================
//   KEYS / IDs
// ================
export var INSTRUCTIONS_EDIT_ID = 'instructionsEdit';
export var ADD_CONTENT_POPOVER_KEY = 'AddContentPopover';
export var SIDEBAR_NAV_ID = 'quiz-react-sdk_sidebar-nav';
export var REMOVE = 'Remove';
export var MOVE = 'Move';
export var EDIT = 'Edit';
export var COPY = 'Copy';

// ========================
//   STIMULUS ORIENTATION
// ========================
export var LEFT = 'left';
export var TOP = 'top';

// ================
//   JWT SCOPES
// ================
export var QUIZ_SESSION_GRADE_SCOPE = 'quiz_session.grade';

// ================
//   MISC
// ================
// dynamo supports 400 KB, so 390,000 characters should
// keep us safely in that limit
export var BUILD_CHAR_LIMIT = 390000;
// Take limit is half of Build since userResponse is
// duplicated in statistics_data for the session_item_response
export var TAKE_CHAR_LIMIT = 195000;
// document tree depth limit is 400, so 390 should keep us safe
export var DOCUMENT_TREE_DEPTH_LIMIT = 390;
export var CONTENT_SIZE_LIMIT = 390000; // same as BUILD_CHAR_LIMIT
export var CONTENT_SIZE_BY_ANSWER = 564;